import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop Component
 *
 * Automatically resets scroll position to top when navigating to a new route.
 * Resets the window scroll (not a container element) since the app layout
 * doesn't restrict scroll to .app-layout__main (it's full window scroll).
 *
 * This follows the official React Router pattern for handling scroll reset on route changes:
 * https://reactrouter.com/en/main/start/faq#how-do-i-scroll-to-the-top-after-a-transition
 *
 * Usage: Place this component in your Router/Layout tree (typically in AppLayout)
 */
export function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    // Reset scroll on every navigation
    // Use location.key as dependency because it changes on EVERY navigation,
    // even with dynamic params (/atleti/123 → /atleti/456)

    // Scroll the AppLayout element (where overflow-y: auto is set)
    const appLayout = document.querySelector('.app-layout');
    if (appLayout) {
      appLayout.scrollTop = 0;
    }
  }, [location.key]);

  // This component doesn't render anything, it's pure logic
  return null;
}
